import { Component, inject, Input, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { PayerData, PayerDocument } from '../../../../features/application/models/payer-data.model';
import { SharedService } from '../../../services/shared.service';
import { RegEntityDocumentPreviewManager } from '../../../managers/document-preview.manager';

@Component({
    selector: 'app-payer-data-modal',
    templateUrl: './payer-data-modal.component.html',
    styleUrls: ['./payer-data-modal.component.scss'],
    standalone: false
})
export class PayerDataModalComponent implements OnInit {

  @Input() payerData!: PayerData;
  @Input() isPayer: boolean = false;
  @Input() isRecipient: boolean = false;

  isVisible: boolean = true;

  public readonly nzModalData: any = inject(NZ_MODAL_DATA);

  constructor(
    public modal: NzModalRef<PayerDataModalComponent>,
    private shared: SharedService,
    private documentPreviewManager: RegEntityDocumentPreviewManager
  ) {}

  ngOnInit(): void {
    this.payerData = this.nzModalData.payerData;
    this.isPayer = this.nzModalData.isPayer;
    this.isRecipient = this.nzModalData.isRecipient;
    if (!this.shared.countries?.length) {
      this.shared.getCountryList().subscribe();
    }
  }

  get displayName(): string {
    if (this.payerData.isBodyCorporate) {
      return this.payerData.companyName || '—';
    }
    return ((this.payerData.firstName || '') + ' ' + (this.payerData.lastName || '')).trim() || '—';
  }

  get subtitle(): string {
    if (this.payerData.isBodyCorporate) {
      return this.payerData.registrationNumber ? 'BIN ' + this.payerData.registrationNumber : '—';
    }
    return this.payerData.email || '—';
  }

  get hasDocuments(): boolean {
    return (this.payerData.identityDocs?.length || 0) > 0 || (this.payerData.certificateDocs?.length || 0) > 0;
  }

  countryName(id: number | undefined): string {
    if (!id) return '—';
    return this.shared.countries?.find(c => c.id === id)?.name || String(id);
  }

  previewFile(doc: PayerDocument) {
    this.documentPreviewManager.openPreview({ fileKey: doc.fileKey, fileName: doc.fileName });
  }
}
